var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "automation-scheduler",
    },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("Configure Scheduler for Automation"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { primary: "", disabled: !_vm.isChanged() },
                on: { click: _vm.save },
              },
              [_vm._v(" Save Changes")]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { ghost: "" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close", 0)
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("close")]),
                _vm._v("\n                Close\n            "),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("RRuleGenerator", {
        attrs: { "max-count": 1000 },
        model: {
          value: _vm.rrule,
          callback: function ($$v) {
            _vm.rrule = $$v
          },
          expression: "rrule",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }